import React from 'react';
import { Star, Calendar, FileText, Heart, User, Sun, BookOpen, HelpCircle } from 'lucide-react';
export const servicePages = ['service-natal', 'service-solar', 'service-compatibility', 'service-combo', 'service-forecast', 'service-consultation'];
export const knowledgePages = ['astro-daily', 'interpretations', 'blog', 'faq'];
export const serviceItems = [{
  page: 'service-natal',
  icon: <Star className="w-4 h-4 text-indigo-500" data-id="element-17393" />,
  labelKey: 'services.natal',
  descKey: 'services.natal.desc'
}, {
  page: 'service-solar',
  icon: <Calendar className="w-4 h-4 text-amber-500" data-id="element-17394" />,
  labelKey: 'services.solar',
  descKey: 'services.solar.desc'
}, {
  page: 'service-combo',
  icon: <FileText className="w-4 h-4 text-slate-500" data-id="element-17395" />,
  labelKey: 'services.combo',
  descKey: 'services.combo.desc'
}, {
  page: 'service-compatibility',
  icon: <Heart className="w-4 h-4 text-rose-500" data-id="element-17396" />,
  labelKey: 'services.compatibility',
  descKey: 'services.compatibility.desc'
}, {
  page: 'service-forecast',
  icon: <Calendar className="w-4 h-4 text-emerald-500" data-id="element-17397" />,
  labelKey: 'services.forecast',
  descKey: 'services.forecast.desc'
}, {
  page: 'service-consultation',
  icon: <User className="w-4 h-4 text-violet-500" data-id="element-17398" />,
  labelKey: 'services.consultation',
  descKey: 'services.consultation.desc'
}];
export const knowledgeItems = [{
  page: 'astro-daily',
  icon: <Sun className="w-4 h-4 text-amber-500" data-id="element-17399" />,
  labelKey: 'Астро-календарь',
  descKey: 'Гороскоп, луна и календарь'
}, {
  page: 'interpretations',
  icon: <BookOpen className="w-4 h-4 text-indigo-500" data-id="element-17400" />,
  labelKey: 'knowledge.interpretations',
  descKey: 'Трактовки планет, домов и аспектов'
}, {
  page: 'blog',
  icon: <FileText className="w-4 h-4 text-emerald-500" data-id="element-17401" />,
  labelKey: 'knowledge.blog',
  descKey: 'Статьи и прогнозы от экспертов'
}, {
  page: 'faq',
  icon: <HelpCircle className="w-4 h-4 text-amber-500" data-id="element-17402" />,
  labelKey: 'Вопросы и ответы',
  descKey: 'Помощь по платформе'
}];